import { render, staticRenderFns } from "./ListItemDetail.vue?vue&type=template&id=1a8a7a34&scoped=true&"
import script from "./ListItemDetail.vue?vue&type=script&lang=js&"
export * from "./ListItemDetail.vue?vue&type=script&lang=js&"
import style0 from "./ListItemDetail.vue?vue&type=style&index=0&id=1a8a7a34&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8a7a34",
  null
  
)

export default component.exports